/* eslint-disable sonarjs/no-commented-code */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CometChatLocalize, CometChatUIKit, UIKitSettingsBuilder } from '@cometchat/chat-uikit-react';
import { setupLocalization } from './sampleApp/src/utils/utils';
import Builder from './components/pages/builder';
import HeaderBanner from './components/layouts/HeaderBanner';

// DEMO CONSTANTS
export const COMETCHAT_CONSTANTS = {
  APP_ID: '267879a77f4b29cd',
  REGION: 'in',
  AUTH_KEY: 'f6211669cfb05a85744f76940d85c620dbc73b75',
  AUTH_TOKEN_URL: 'https://demo-service.cometchat.io/auth-token',
};

/**
 * Initializes CometChat UI Kit if all necessary credentials are provided.
 */
if (COMETCHAT_CONSTANTS.APP_ID && COMETCHAT_CONSTANTS.REGION && COMETCHAT_CONSTANTS.AUTH_KEY) {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(COMETCHAT_CONSTANTS.APP_ID)
    .setRegion(COMETCHAT_CONSTANTS.REGION)
    .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
    .subscribePresenceForAllUsers()
    .build();
  /*
   * Note:
   * If you need to update the localization strings for a specific language in the UI Kit,
   * use the `CometChatLocalize.init` method. This allows you to override or add custom
   * translations for a language. Here's an example:
   *
   * CometChatLocalize.init('fr', {
   *     'fr': {
   *         "CONTINUE": "Continuer",
   *         "NAME": "Nom",
   *     }
   * });
   *
   * In this example, the French localization is updated with custom strings for "CONTINUE" and "NAME".
   */

  // Initialize localization with custom translations
  CometChatUIKit.init(uiKitSettings)?.then(() => {
    CometChatLocalize.init({
      translationsForLanguage: {
        'en-US': {
          members_remove: 'Kick',
          members_block: 'Ban',
        },
        'en-GB': {
          members_remove: 'Kick',
          members_block: 'Ban',
        },
      },
    });
    setupLocalization();

    CometChatUIKit.getLoggedinUser().then((user: CometChat.User | null) => {
      if (!user) {
        fetch(COMETCHAT_CONSTANTS.AUTH_TOKEN_URL)
          .then((response) => response.json())
          .then((res) => {
            if (res.authToken) {
              // Use CometChat's loginWithAuthToken method to log the user in
              CometChatUIKit.loginWithAuthToken(res.authToken)
                .then((loggedInUser) => {
                  console.log('Login successful, loggedInUser:', loggedInUser);
                })
                .catch((error) => {
                  console.error('Login failed:', error);
                });
            } else {
              console.error('No authToken received');
            }
          })
          .catch((error) => {
            console.error('Error fetching authToken:', error);
          });
      }
    });
    // const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    // root.render(<App />);
  });
}

export { default as App } from './App';
export { Builder };
export { HeaderBanner };
